export const mapBackgroundValues = value => value.toLowerCase();
